import { gql } from '@apollo/client';
import type { SerializedInventoryMeter } from '@enmon/commons/lib/tools';

export const GET_INVENTORY_METERS_LIST_DATA = gql`
  query getInventoryMeterListData($filter: InventoryMeterFiltersInput, $limit: Int, $sort: [String], $start: Int) {
    inventoryMeters(filters: $filter, pagination: { limit: $limit, start: $start }, sort: $sort) {
      # table columns
      data {
        id
        attributes {
          submitted_at
          installed_at
          replaced_at
          serviced_at
          serviced_by
          updatedAt
          merged_at
          merged_into {
            data {
              id
            }
          }
          inventory_location {
            data {
              id
              attributes {
                customer {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export interface InventoryMetersCardVariables {
  limit: number;
  sort?: string[];
  start: number;
}

export type InventoryMeterData = Pick<
  SerializedInventoryMeter,
  | 'id'
  | 'installed_at'
  | 'inventory_location'
  | 'merged_at'
  | 'replaced_at'
  | 'serviced_at'
  | 'serviced_by'
  | 'submitted_at'
  | 'updatedAt'
> & {
  inventory_location: { customer: { name: string } | null };
  merged_into: { id: number } | null;
};

export interface InventoryMeterQueryData {
  inventoryMeters: {
    data: InventoryMeterData[];
    meta: { pagination: { total: number } };
  };
}
